import React from "react";
import "./vikas.css";

const VikasKame = () => {
  const works = [
    // --- Existing development works ---
    {
      title: "✅ पाणीपुरवठा योजना सुधारणा",
      desc: "गावातील पाण्याची समस्या सोडवण्यासाठी नवीन नळ लाईन आणि टाकी दुरुस्तीचे काम पूर्ण.",
      year: "2024-25",
    },
    {
      title: "✅ रस्ते काँक्रिटीकरण",
      desc: "मुख्य रस्ते तसेच अंतर्गत गल्ली रस्त्यांचे सीसी (CC) रोड बांधकाम पूर्ण.",
      year: "2023-24",
    },
    {
      title: "✅ ग्रामपंचायत इमारत देखभाल",
      desc: "ग्रामपंचायत कार्यालयाचे नूतनीकरण, रंगकाम, वीजयोजना अपग्रेडेशन.",
      year: "2024",
    },
    {
      title: "✅ LED स्ट्रीट लाइट बसविणे",
      desc: "पर्यावरणपूरक LED लाईट्स बसवून ऊर्जा बचत वाढवली.",
      year: "2023",
    },
    {
      title: "✅ जलसंधारण कामे",
      desc: "पाणी आडवा-पाणी जिरवा अंतर्गत बंधारे, नालेसफाई, गाळकाढणीची कामे.",
      year: "2022-23",
    },
    {
      title: "✅ स्वच्छता अभियान",
      desc: "स्वच्छ भारत मिशन अंतर्गत सार्वजनिक ठिकाणांची स्वच्छता व जागरूकता मोहीम.",
      year: "2024",
    },

    // --- Started & Completed Work Sections ---
    {
      title: "🔧 सुरू असलेली विकासकामे",
      desc:
        "१) नाली बांधकाम\n" +
        "२) नाली सफाई\n" +
        "३) पेव्हर ब्लॉक (ग्रा.पं.भवन, हनुमान मंदिर परिसर)",
      year: "2024-25",
    },
    {
      title: "🏁 पूर्ण झालेली विकासकामे",
      desc:
        "१) स्मशानभूमी सिमेंट रोड\n" +
        "२) ढेपे ले-आऊट सिमेंट रोड",
      year: "2023-24",
    },

    // --- Annual Plan ---
    {
      title: "📘 वार्षिक विकास आराखडा",
      desc: "ग्रामपंचायत वार्षिक विकास आराखडा सार्वजनिक नियोजनानुसार राबविण्यात येत आहे.",
      year: "2024-25",
    },

    // --- Citizen Services ---
    {
      title: "👥 नागरिक सेवा",
      desc:
        "* जन्म नोंद दाखला\n" +
        "* मृत्यू नोंद दाखला\n" +
        "* विवाह नोंद दाखला\n" +
        "* प्रतिज्ञापत्र (Affidavit)\n" +
        "* उत्पन्न प्रमाणपत्र\n" +
        "* नॉन-क्रिमिलेअर प्रमाणपत्र\n" +
        "* जात प्रमाणपत्र\n" +
        "* जन्म/मृत्यू प्रमाणपत्र",
      year: "नियमित सेवा",
    },

    // --- Population and Facilities ---
    {
      title: "🏡 गावातील मूलभूत सुविधा",
      desc:
        "लोकसंख्या: १३४५\n" +
        "शाळा: ०२\n" +
        "आरोग्य केंद्र: ०\n" +
        "अंगणवाडी: ०२\n" +
        "सार्वजनिक सुविधा: ०१",
      year: "2024",
    },

    // --- Other information ---
    {
      title: "ℹ️ इतर महत्वाची माहिती",
      desc:
        "• पूर्ण गावाला आरो पाणी मोफत उपलब्ध केले\n" +
        "• पाच लाखांचे माता मंदिर बांधकाम\n" +
        "• तलाव खोलीकरण व तलाव सफाई\n",
      year: "2024",
    },

    // --- Address ---
    {
      title: "📍 कार्यालयाचा पत्ता",
      desc:
        "मु. पिपरा,  तह.उमरेड, जिल्हा नागपूर\nईमेल: gppipara@gmail.com",
      year: "",
    },

    // --- Schemes Section (New Added as per your request) ---
    {
      title: "🎯 विविध शासकीय योजना",
      desc:
        "१) मुख्यमंत्री लाडकी बहिण योजना\n" +
        "२) प्रधानमंत्री आवास योजना\n" +
        "३) आयुष्मान भारत कार्ड योजना\n" +
        "४) वयोश्री योजना\n" +
        "५) श्रम कार्ड योजना\n" +
        "६) निराधार योजना\n" +
        "७) संजय गांधी योजना\n" +
        "८) लेक लाडकी योजना\n" +
        "९) प्रधानमंत्री विश्वकर्मा योजना\n" +
        "१०) दिव्यांग निधी लाभ योजना",
      year: "चालू वर्ष",
    },
  ];

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">🏗 विकास कामे (Development Works)</h2>

      <div className="vikas-grid">
        {works.map((work, index) => (
          <div className="vikas-card" key={index}>
            <h3 className="work-title">{work.title}</h3>
            <p className="work-desc" style={{ whiteSpace: "pre-line" }}>
              {work.desc}
            </p>
            {work.year && <p className="work-year">📅 वर्ष : {work.year}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VikasKame;
